import { CgMenuBoxed } from 'react-icons/cg';
import styled from 'styled-components';
import { blueGray, outlineGray, primaryColor, primaryColorLight, textGrey } from '../../config/colors';
import Button from '../Button';

export const Container = styled.div`
  border: 1px solid ${outlineGray};
  padding: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Section = styled.div`
  height: 40px;
`;

export const SliderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const SliderLine = styled.div`
  height: 2px;
  background-color: ${outlineGray};
  width: 100%;
  position: relative;
`;

export const SliderSection = styled(Section)`
  display: grid;
  grid-template-columns: 85px auto 85px;
`;

export const DragCircle = styled.div`
  border-radius: 50%;
  transition: opacity: 0.3s ease-out;
  background-color: white;
  box-sizing: border-box;
  border: 2px solid  ${outlineGray};
  cursor: pointer;
  position: absolute;
  left: ${({ percentageValue }) => `calc(${percentageValue}% - 18px / 2)`};
  width: 18px;
  height: 18px;
  user-select: none;
  top: calc(50% - 18px / 2);


  transition: left .1s ease-out, opacity 0.3s ease-out, background-color .3s ease-out, border-color .3s ease-out;

  &:active {
    border-color: ${primaryColor};
  }

 
`;

export const HighlightedLine = styled.div`
  background-color: ${primaryColor};
  height: 4px;
  width: ${({ highlightLineStyles }) => highlightLineStyles.width}%;
  position: absolute;
  left: ${({ highlightLineStyles }) => highlightLineStyles.left}%;
  top: calc(50% - 4px / 2);
  transition: left 0.1s ease-out, width 0.1s ease-out;
`;

export const InfoLabel = styled.label`
  display: inline-block;
  font-weight: 500;
  min-width: 100px;
  font-size: 0.9rem;
  margin-right: 1rem;
`;

export const AxisLabel = styled.label`
  font-weight: 700;
  font-size: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconCross = styled.div`
  width: 18px;
  height: 18px;
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 0.8rem;
  color: ${blueGray};
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid transparent;
  transition: border-color 0.3s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
    border-color: ${outlineGray};
  }
`;

export const DetailsSection = styled(Section)`
  display: flex;
  align-items: center;
`;

export const InputField = styled.input`
  outline: none;
  border: none;
  border: 1px solid ${outlineGray};
  width: 50px;
  height: 35px;
  border-radius: 4px;
  display: block;
  text-align: center;
`;

export const InputDelimiterLabel = styled.div`
  width: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 1rem;
`;
